if (!customElements.get('quick-add-button')) {
  customElements.define(
    'quick-add-button',
    class QuickAddButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.onClick.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onClick() {
        if (this.button.hasAttribute('disabled')) return;

        if (!this.cart) {
          window.location = `${routes.cart_add_url}?id=${this.dataset.variantId}&quantity=1`;
          return;
        }

        this.button.setAttribute('aria-disabled', true);
        this.button.classList.add('loading');
        this.cart.setActiveElement(document.activeElement);

        const formData = new FormData();
        formData.append('id', this.dataset.variantId);
        formData.append('quantity', 1);
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);

        const config = fetchConfig('javascript');
        delete config.headers['Content-Type'];
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.location = `${routes.cart_add_url}?id=${this.dataset.variantId}&quantity=1`;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add-button',
              productVariantId: this.dataset.variantId,
              cartData: response,
            });
            this.cart.renderContents(response);
          })
          .catch(() => {
            window.location = `${routes.cart_add_url}?id=${this.dataset.variantId}&quantity=1`;
          })
          .finally(() => {
            this.button.classList.remove('loading');
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
